import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { ConnectButton } from '@rainbow-me/rainbowkit';
import "./mobilemenu.css"
import { TOKEN_SYMBOL } from "../../../utils/constants";
import { useTranslation } from 'react-i18next';

interface MobileMenuProps {
  open: boolean;
  onClose: () => void;
  setShowMacrostrategyModal: (value: boolean) => void;
  setShowRefer: (value: boolean) => void;
  setShowTerminalModal: (value: boolean) => void;
  setShowAccountModal: (value: boolean) => void;
  account: any;
}

const MobileMenu: React.FC<MobileMenuProps> = ({ open, onClose, setShowMacrostrategyModal, setShowRefer, setShowTerminalModal, setShowAccountModal, account }) => {
  const { t, i18n } = useTranslation();
  // MODAL OPEN AND CLOSE
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="sc-92636bb2-8 bObKeP">
      <nav className="sc-92636bb2-4 gqvGVn">
        <a target="_self" className="sc-92636bb2-6 iWCwVS" href="/farms">
          {t("menu_header.farms")}
        </a>
        <a className="sc-92636bb2-6 iWCwVS" href="/mystery-box">
          {t("menu_header.mystery_box")}
        </a>
        <a className="sc-92636bb2-6 iWCwVS" href="/leaderboard"> {/* If disabled use the hcikYB class */}
          {t("menu_header.leaderboard")}
        </a>
        <a
          target="_blank"
          className="sc-92636bb2-6 iWCwVS"
          href="https://www.shadow.so/trade?inputCurrency=0x0000000000000000000000000000000000000000&outputCurrency=0xA052cC4dD2138504Dd89E723D72636D491b4cEd9"
        >
          {t("menu_header.trade")} ${TOKEN_SYMBOL}
        </a>
        <a target="_blank" className="sc-92636bb2-6 iWCwVS" href="https://docs.milkit.finance/">
          {t("menu_header.about")}
        </a>
        <a className="sc-92636bb2-6 iWCwVS" href="/disclaimer">
          {t("menu_header.disclaimer")}
        </a>
        <div style={{}}>
          <div className="sc-9bbd01c4-1 izPSem">
            {/* <button className="sc-cdc39d4e-0 sc-9bbd01c4-0 gvrgXY gXvsv" onClick={() => setShowMacrostrategyModal(true)} style={{ display: account ? account.isConnected ? "flex" : "none" : "none" }}>
              MACROSTRATEGY
            </button> */}
            <button className="sc-cdc39d4e-0 sc-9bbd01c4-0 gvrgXY gXvsv" onClick={() => setShowRefer(true)} style={{ display: account ? account.isConnected ? "flex" : "none" : "none" }}>
              {t("menu_header.refer")}
            </button>
            <button className="sc-cdc39d4e-0 sc-9bbd01c4-0 gvrgXY gXvsv" onClick={() => setShowTerminalModal(true)} style={{ display: account ? account.isConnected ? "flex" : "none" : "none" }}>
              <svg width={14} height={14} viewBox="0 0 143 148" fill="none">
                <path
                  d="M18 42V108H116L117 109V124L116 125H112L110 123V117H3L2 118V137L3 138V139L4 140H8L9 141V145L10 146H118V141L119 140H124L125 139V42H18Z"
                  fill="#507c83"
                  stroke="#507c83"
                  strokeWidth={4}
                />
                <path
                  d="M127 12L126 13V26L127 27H131L132 28V39L133 40V41L134 42H139L140 41V40L141 39V13L140 12H127Z"
                  fill="#507c83"
                  stroke="#507c83"
                  strokeWidth={4}
                />
                <path
                  d="M48 3L47 4H10L9 5V11L8 12H3L2 13V32L3 33H118V13L119 12H124L126 10V9L125 8L126 7L125 6V4H49L48 3Z"
                  fill="#507c83"
                  stroke="#507c83"
                  strokeWidth={4}
                />
              </svg>
            </button>
            <ConnectButton.Custom>
              {({
                account,
                chain,
                openAccountModal,
                openChainModal,
                openConnectModal,
                authenticationStatus,
                mounted,
              }) => {
                const ready = mounted && authenticationStatus !== 'loading';
                const connected = ready && account && chain && (!authenticationStatus || authenticationStatus === 'authenticated');

                return (
                  <button className="sc-cdc39d4e-0 sc-9bbd01c4-0 gvrgXY gXvsv" {...(!ready && { 'aria-hidden': true, style: { opacity: 0, pointerEvents: 'none', userSelect: 'none' } })} onClick={() => {
                    if (!connected) {
                      openConnectModal();
                    } else if (chain?.unsupported) {
                      openChainModal();
                    } else {
                      setShowAccountModal(true);
                    }
                  }}>
                    {(() => {
                      if (!connected) {
                        return (
                          <div
                          // onClick={openConnectModal}
                          >
                            {t("menu_header.connect_wallet")}
                          </div>
                        );
                      }

                      if (chain.unsupported) {
                        return (
                          <div
                          // onClick={openChainModal}
                          >
                            [{t("menu_header.wrong_network")}]
                          </div>
                        );
                      }

                      return (
                        // <div onClick={openAccountModal}>
                        <div>
                          <svg width={15} height={15} viewBox="0 0 86 100" fill="none">
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M51.2996 12.4814H34.6356V4.14941H51.2996V12.4814ZM59.6355 20.8134V12.4814H51.2996V20.8134H59.6355ZM59.6355 37.4814V20.8134H67.9675V37.4814H59.6355ZM51.2996 45.8134V37.4814H59.6355V45.8134H51.2996ZM34.6356 45.8134H51.2996V54.1493H34.6356V45.8134ZM26.2997 37.4814V45.8134H34.6356V37.4814H26.2997ZM26.2997 20.8134V37.4814H17.9677V20.8134H26.2997ZM26.2997 20.8134H34.6356V12.4814H26.2997V20.8134ZM63.7997 87.4814H22.1357V79.1494H9.6357V70.8135H17.9677V62.4815H30.4677V54.1495H17.9677V62.4815H9.6357V70.8135H1.2998V79.1494H9.6357V87.4814H22.1357V95.8134H63.7997V87.4814ZM76.2997 79.1494V87.4814H63.7997V79.1494H76.2997ZM76.2997 70.8135H84.6356V79.1494H76.2997V70.8135ZM67.9677 62.4815V70.8135H76.2997V62.4815H67.9677ZM67.9677 62.4815H55.4677V54.1495H67.9677V62.4815Z"
                              fill="#507c83"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M51.2996 9.48141H34.6356V1.14941H51.2996V9.48141ZM59.6355 17.8134V9.48141H51.2996V17.8134H59.6355ZM59.6355 34.4814V17.8134H67.9675V34.4814H59.6355ZM51.2996 42.8134V34.4814H59.6355V42.8134H51.2996ZM34.6356 42.8134H51.2996V51.1493H34.6356V42.8134ZM26.2997 34.4814V42.8134H34.6356V34.4814H26.2997ZM26.2997 17.8134V34.4814H17.9677V17.8134H26.2997ZM26.2997 17.8134H34.6356V9.48141H26.2997V17.8134ZM63.7997 84.4814H22.1357V76.1494H9.6357V67.8135H17.9677V59.4815H30.4677V51.1495H17.9677V59.4815H9.6357V67.8135H1.2998V76.1494H9.6357V84.4814H22.1357V92.8134H63.7997V84.4814ZM76.2997 76.1494V84.4814H63.7997V76.1494H76.2997ZM76.2997 67.8135H84.6356V76.1494H76.2997V67.8135ZM67.9677 59.4815V67.8135H76.2997V59.4815H67.9677ZM67.9677 59.4815H55.4677V51.1495H67.9677V59.4815Z"
                              fill="#507c83"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M51.2996 15.4814H34.6356V7.14941H51.2996V15.4814ZM59.6355 23.8134V15.4814H51.2996V23.8134H59.6355ZM59.6355 40.4814V23.8134H67.9675V40.4814H59.6355ZM51.2996 48.8134V40.4814H59.6355V48.8134H51.2996ZM34.6356 48.8134H51.2996V57.1493H34.6356V48.8134ZM26.2997 40.4814V48.8134H34.6356V40.4814H26.2997ZM26.2997 23.8134V40.4814H17.9677V23.8134H26.2997ZM26.2997 23.8134H34.6356V15.4814H26.2997V23.8134ZM63.7997 90.4814H22.1357V82.1494H9.6357V73.8135H17.9677V65.4815H30.4677V57.1495H17.9677V65.4815H9.6357V73.8135H1.2998V82.1494H9.6357V90.4814H22.1357V98.8134H63.7997V90.4814ZM76.2997 82.1494V90.4814H63.7997V82.1494H76.2997ZM76.2997 73.8135H84.6356V82.1494H76.2997V73.8135ZM67.9677 65.4815V73.8135H76.2997V65.4815H67.9677ZM67.9677 65.4815H55.4677V57.1495H67.9677V65.4815Z"
                              fill="#507c83"
                            />
                          </svg>
                        </div>
                      );
                    })()}
                  </button>
                );
              }}
            </ConnectButton.Custom>
          </div>
        </div>
      </nav>
    </div>

  );
}
export default MobileMenu;